import React from "react";
import PageHero from "../../components/common/PageHero";
import DataTableCard from "../../components/common/DataTableCard";

export default function Account() {
  return (
    <div className="erp-page-grid">
      <PageHero title="All Accounts" />

      <DataTableCard
        columns={[
          { key: "name", label: "Name" },
          { key: "type", label: "Type" },
          { key: "mobile", label: "Mobile" },
        ]}
        rows={[
          { name: "Ramesh", type: "User", mobile: "9999999999" },
        ]}
      />
    </div>
  );
}